/**
 * This file is the App entrypoint for POS embeds
 */

import { AppProvider } from '@shopify/polaris';

import React, { useState } from 'react';
import { Route, BrowserRouter, Routes } from 'react-router-dom';
import { NavMenu } from '@shopify/app-bridge-react';

import PosIndexPage from './pages/PosIndexPage';
import FormOrderPage from './pages/FormOrderPage';
import PosOrderListingPage from './pages/PosOrderListingPage';
import PreIssuedFormCompletePage from './pages/PreIssuedFormCompletePage';
import ScanReceipts from './pages/ScanReceipts';
import translations from '@shopify/polaris/locales/en.json';
import ConfigurePrinter from './pages/ConfigurePrinter';

function GetApp() {
    const router = (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<PosIndexPage />} />
                <Route path="orders">
                    <Route index element={<PosOrderListingPage />} />
                    <Route path="form" element={<FormOrderPage />} />
                    <Route path="scan" element={<ScanReceipts />} />
                </Route>
                <Route path="pre-issued-forms/:id/details" element={<PreIssuedFormCompletePage />} />
                <Route path="printer" element={<ConfigurePrinter />} />
            </Routes>
        </BrowserRouter>
    );

    return function App() {
        return (
            <React.StrictMode>
                <AppProvider i18n={translations}>{router}</AppProvider>
            </React.StrictMode>
        );
    };
}

export default GetApp;
